import { render, staticRenderFns } from "./TwelvethSection.vue?vue&type=template&id=2fce7c0e&scoped=true&"
import script from "./TwelvethSection.vue?vue&type=script&lang=js&"
export * from "./TwelvethSection.vue?vue&type=script&lang=js&"
import style0 from "./TwelvethSection.vue?vue&type=style&index=0&id=2fce7c0e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fce7c0e",
  null
  
)

export default component.exports